
const SPECIAL_CHARS = [{replacement : '&', regex: /&amp;/g},
{replacement : '"', regex: /&quot;/g},
{replacement : '£', regex: /&pound;/g},
{replacement : '€', regex: /&euro;/g},
{replacement : 'é', regex: /&eacute;/g},
{replacement : '–', regex: /&ndash;/g},
{replacement : '®', regex: /&reg;/g},
{replacement : '™', regex: /&trade;/g},
{replacement : '‘', regex: /&lsquo;/g},
{replacement : '’', regex: /&rsquo;/g},
{replacement : '“', regex: /&ldquo;/g},
{replacement : '”', regex: /&rdquo;/g},
{replacement : '#', regex: /&#35;/g},
{replacement : '©', regex: /&copy;/g},
{replacement : '@', regex: /&commat;/g},
{replacement : '$', regex: /&dollar;/g},
{replacement : '\\(', regex: /&#40;/g},
{replacement : '\\)', regex: /&#41;/g},
{replacement : '<', regex: /&lt;/g},
{replacement : '>', regex: /&gt;/g},
{replacement : '…', regex: /&hellip;/g},
{replacement : '-', regex: /&#45;/g},
{replacement : "'", regex: /&#39;/g},
{replacement : '\\*', regex: /&#42;/g},
{replacement : ',', regex: /&sbquo;/g},
{replacement : ' ', regex: /&nbsp;/g},
]

function sanitizeHTMLSpecialChars(input:string){
    const tempNode = document.createElement("div")
    tempNode.innerHTML = input
    let sanitizedText = tempNode.innerHTML
    SPECIAL_CHARS.forEach(item=>{
        sanitizedText = sanitizedText.replaceAll(item.regex, item.replacement);
    })
    return sanitizedText

}

export default sanitizeHTMLSpecialChars

